import MenuItems from "./MenuItems";

const DesktopMenu = ({ isLogin, userInfo, handleClick }) => {
  return (
    <nav className="contents">
      <ul className="invisible lg:visible lg:flex items-center font-medium justify-center gap-3 font-poppins">
        <MenuItems
          isLogin={isLogin}
          userInfo={userInfo}
          handleClick={handleClick}
        />
      </ul>
    </nav>
  );
};

export default DesktopMenu;
